import { AppLoader } from './AppLoader.main';

export { AppLoader };
